import { Component } from '@angular/core';
import { MenuController, ModalController } from '@ionic/angular';
import { GlobalService } from '../../services/global.service';
import { BarcodeScanner, BarcodeScannerOptions } from '@ionic-native/barcode-scanner/ngx';
import { ProductDetailsComponent } from "../../pages/product-details/product-details.component"
import { Product } from 'src/app/models/product.model';


@Component({
    selector: 'app-tabs',
    templateUrl: 'tabs.page.html',
    styleUrls: ['tabs.page.scss']
})
export class TabsPage {

    scannedData: any;
    encodedData: '';
    encodeData: any;
    inputData: any;

    constructor(
        public global: GlobalService,
        private menuController: MenuController,
        private barcodeScanner: BarcodeScanner,
        public modalController: ModalController

    ) {
        this.menuController.enable(true); // Enable side menu
    }

    ionViewDidEnter() {
        document.querySelector('#tab-button-tab3').shadowRoot.querySelector('.button-native').setAttribute('style', 'margin-top: -20px');
    }

    async buscarEan(valor: string): Promise<Product | null> {
        if (!this.global.products) {
          return null;
        }
      
        const producto = this.global.products.find(elemento => {
          const ean = elemento.eans.find(subElemento => ((subElemento.ean === valor)||(subElemento.ean === this.global.rellenarCeros(valor,15))) );
          return ean !== undefined;
        });
      
        return producto || null;
      }

    async leeEanQR() {
        
        const options: BarcodeScannerOptions = {
            preferFrontCamera: false,
            showFlipCameraButton: true,
            showTorchButton: true,
            torchOn: false,
            prompt: 'Situe el ccódigo en el recuadro',
            resultDisplayDuration: 500,
            formats: 'EAN_13,EAN_8,QR_CODE,PDF_417,CODE_128',
            orientation: 'portrait',
        };

        this.barcodeScanner.scan(options).then(async barcodeData => {
            console.log('Barcode data', barcodeData);
            this.scannedData = barcodeData;
            if( !this.scannedData.cancelled )
            {
                let producto = await this.buscarEan(this.scannedData.text);

                if (producto) {
                    const modal = await this.modalController.create({
                        component: ProductDetailsComponent,
                        componentProps: { producto: producto },
                    });
                    await modal.present();
                }
                else
                    alert("Desconocido !!!");
            }

        }).catch(err => {
            console.log('Error', err);
            alert(err);
        });
    }

    createBarcode() {
        this.barcodeScanner.encode(this.barcodeScanner.Encode.TEXT_TYPE, this.inputData).then((encodedData) => {
            console.log(encodedData);
            this.encodedData = encodedData;
        }, (err) => {
            console.log('Error occured : ' + err);
        });
    }
}
